import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { authconfig } from './config.js';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { ErrorBoundary } from 'react-error-boundary';
import { AppErrorBoundary } from './component/component.js';

Amplify.configure(authconfig)
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary fallback={<AppErrorBoundary />} >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
